import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Menu, Clock } from 'lucide-react';

interface HeaderProps {
  toggleSidebar: () => void;
  isSidebarOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar, isSidebarOpen }) => {
  const { user } = useAuth();
  const [now, setNow] = useState<Date>(new Date());
  const timeZone = 'Asia/India';

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="header sticky top-0 border-b border-border-dark">
      <div className="flex items-center gap-4">
        <button 
          onClick={toggleSidebar}
          className="header-action md:hidden"
          aria-label="Toggle sidebar"
        >
          <Menu size={20} />
        </button>
        
        {/* Greeting and time on the left side */}
        <div className="hidden md:flex items-center gap-3 text-sm">
          <span>
            Hello <span className="font-bold">{([user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.username || 'Unknown')}</span>!
          </span>
          <span className="text-gray-500">|</span>
          <span className="flex items-center gap-1">
            <Clock size={14} className="text-gray-400" />
            {now.toLocaleTimeString()} ({timeZone})
          </span>
        </div>
      </div>
      
    </header>
  );
};

export default Header; 